import Button from './button';
export type { ButtonProps } from './button.types';

export default Button;
